import React, { createContext, useState, useEffect } from "react";

export const UniversidadesContext = createContext();

export function UniversidadesProvider({ children }) {
    const [universidades, setUniversidades] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchUniversidades = async () => {
        try {
            const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3002';
            const token = localStorage.getItem('token');

            const response = await fetch(`${API_URL}/master/universidades`, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });

            if (!response.ok) {
                throw new Error('Erro ao buscar universidades');
            }

            const data = await response.json();
            setUniversidades(data);
            setLoading(false);
        } catch (error) {
            console.error("Erro ao buscar universidades:", error);
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchUniversidades();
    }, []);

    return (
        <UniversidadesContext.Provider value={{ universidades, loading, fetchUniversidades }}>
            {children}
        </UniversidadesContext.Provider>
    );
}
